import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axiosAdminAuth';
import { IAdminAuth } from 'src/@types/admin-auth';

interface AdminLoginResponse {
  token: string;
  admin: { id: string; nome: string; email: string };
}

interface AdminRegisterResponse {
  mensagem: string;
  admin: { id: string; nome: string; email: string };
}

export const postAdminLogin: any = createAsyncThunk<
  AdminLoginResponse,
  { email: string; senha: string }
>('adminAuth/postAdminLogin', async ({ email, senha }, thunkAPI) => {
  try {
    const response = await axios.post('/admin/login', { email, senha });
    return response.data;
  } catch (error: any) {
    const message = error?.erro || error?.message || 'Erro ao fazer login';
    return thunkAPI.rejectWithValue(message);
  }
});

export const postAdminRegister: any = createAsyncThunk<
  AdminRegisterResponse,
  { nome: string; email: string; senha: string; codigo: string }
>('adminAuth/postAdminRegister', async (dados, thunkAPI) => {
  try {
    const response = await axios.post('/admin/register', dados);
    return response.data;
  } catch (error: any) {
    const message = error?.erro || error?.message || 'Erro ao registrar admin';
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState: IAdminAuth = {
  accessToken: '',
  admin: { id: '', nome: '', email: '' },
  isLoading: false,
  error: null,
};

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    adminLogout: (state) => {
      state.accessToken = '';
      state.admin = { ...initialState.admin };
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postAdminLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(postAdminLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.accessToken = action.payload.token;
        state.admin = action.payload.admin;
        state.error = null;
      })
      .addCase(postAdminLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.accessToken = '';
        state.admin = { ...initialState.admin };
        state.error = (action.payload as string) || 'Erro ao fazer login';
      })
      .addCase(postAdminRegister.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(postAdminRegister.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(postAdminRegister.rejected, (state, action) => {
        state.isLoading = false;
        state.error = (action.payload as string) || 'Erro ao registrar admin';
      });
  },
});

export const { adminLogout } = adminAuthSlice.actions;

export default adminAuthSlice.reducer;
